/*
 * Personal Digital Spaces LLC ("COMPANY") CONFIDENTIAL
 * Unpublished Copyright (c) 2026 Personal Digital Spaces LLC, All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of COMPANY. The intellectual and technical concepts contained
 * herein are proprietary to COMPANY and may be covered by U.S. and Foreign Patents, patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained
 * from COMPANY.  Access to the source code contained herein is hereby forbidden to anyone except current COMPANY employees, managers, contractors or partners who have executed
 * Confidentiality and Non-disclosure agreements explicitly covering such access.
 *
 * The copyright notice above does not evidence any actual or intended publication or disclosure  of  this source code, which includes
 * information that is confidential and/or proprietary, and is a trade secret, of  COMPANY.   ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC  PERFORMANCE,
 * OR PUBLIC DISPLAY OF OR THROUGH USE  OF THIS  SOURCE CODE  WITHOUT  THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE
 * LAWS AND INTERNATIONAL TREATIES.  THE RECEIPT OR POSSESSION OF  THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS
 * TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT  MAY DESCRIBE, IN WHOLE OR IN PART.
 */
import React from 'react'
import {
  HStack,
  VStack,
  Text
} from '@chakra-ui/react'
import { CiCirclePlus } from 'react-icons/ci'
import DefaultModal from '@/components/modal/DefaultModal'
import OriginalAssetSection from '@/components/license-history/license-history-summary-modal/OriginalAssetSection'
import UserSection from '@/components/license-history/license-history-summary-modal/UserSection'
import ListingTermsSection from '@/components/license-history/license-history-summary-modal/ListingTermsSection'
import OriginalListingSection from './components/OriginalListingSection'
import StateSection from '@/components/license-history/license-history-summary-modal/StateSection'

const BuildAcquiredModal = ({ isOpen, onClose, data }) => {
  if (!data) return null

  const creatorNames = data.asset?.creators.map(creator => creator.name)
  const publisherNames = data.asset?.publishers.map(publisher => publisher.name)
  const TitleComponent = () => {
    return (
      <HStack spacing={3}>
        <CiCirclePlus className="text-xl text-gray-600" />
        <Text>BUILD License Acquired</Text>
      </HStack>
    )
  }

  return (
    <DefaultModal
      isOpen={isOpen}
      onClose={onClose}
      scrollBehavior="inside"
      titleComponent={TitleComponent}
    >
      <VStack spacing={3} align="stretch">
        { data.asset &&
          <OriginalAssetSection
            title={data.asset.title}
            assetId={data.asset.assetId}
            creatorNames={creatorNames}
            publisherNames={publisherNames}
          />
        }
        <UserSection
          title="License Acquired By"
          nickname={data.user?.nickname}
          zetoniumId={data.user?.zetoniumId}
        />
        { data.buildLicenseListingTerms?.user &&
          <UserSection
            title="Licensed From"
            nickname={data.buildLicenseListingTerms?.user.nickname}
            zetoniumId={data.buildLicenseListingTerms?.user?.zetoniumId}
          />
        }
        <ListingTermsSection
          createdAt={data.createdAt}
          licenseTerm={data.licenseTerm}
          minimumPrice={data.minimumPrice}
          numberOfLicenses={data.numberOfLicenses}
          requiredRoyalty={data.requiredRoyalty}
          usageFee={data.usageFee}
          usageLimit={data.usageLimit}
        />
        <OriginalListingSection
          createdAt={data.buildLicenseListingTerms.createdAt}
          price={data.buildLicenseListingTerms.minimumPrice}
          state={data.buildLicenseListingTerms.state}
        />
        <StateSection
          state={data.state}
          updatedAt={data.updatedAt}
          hasDivider={false}
        />
      </VStack>
    </DefaultModal>
  )
}

export default BuildAcquiredModal
